<template>
  <div class="status-items">
    <div
      v-for="(label, index) in labels"
      :key="index"
      :class="{ active: label === highlightedItem }"
      >{{ label }}</div
    >
  </div>
</template>

<script>
export default {
  props: {
    labels: {
      type: Array,
      required: true,
    },
    highlightedItem: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.status-items {
  display: flex;
  div {
    flex-grow: 1;
    padding: 5px;
    font-size: 0.8em;
    text-align: center;
    opacity: 0.3;
  }
  div.active {
    color: rgb(100, 100, 255);
    opacity: 1;
  }
}
</style>
